import {
  CartesianGrid,
  Legend,
  Line,
  LineChart as RechartsLineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

interface SeriesConfig {
  dataKey: string;
  name: string;
  color: string;
}

interface LineChartProps {
  data: Record<string, unknown>[];
  series: SeriesConfig[];
}

const LineChart = ({ data, series }: LineChartProps) => (
  <div className="chart-frame">
    <ResponsiveContainer width="100%" height={300}>
      <RechartsLineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="rgba(24, 34, 48, 0.08)" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <Legend />
        {series.map(item => (
          <Line
            key={item.dataKey}
            type="monotone"
            dataKey={item.dataKey}
            name={item.name}
            stroke={item.color}
            strokeWidth={3}
            dot={false}
          />
        ))}
      </RechartsLineChart>
    </ResponsiveContainer>
  </div>
);

export default LineChart;
